import type { RequestInterface } from '~/common/types';
import type { WorkflowRequest } from '../../types';

export class WorkflowsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/workflows';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CreateWorkflowRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/workflows';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    workflow,
  }: {
    token: string;
    workflow: WorkflowRequest;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...workflow,
    };
  }
}

export class GetWorkflowRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    workflowId,
    params,
  }: {
    token: string;
    workflowId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/workflows/${workflowId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateWorkflowRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    workflowId,
    workflow,
  }: {
    token: string;
    workflowId: string;
    workflow: WorkflowRequest;
  }) {
    this.path = `/api/v1/workflows/${workflowId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...workflow,
    };
  }
}

export class DeleteWorkflowRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, workflowId }: { token: string; workflowId: string }) {
    this.path = `/api/v1/workflows/${workflowId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class ImportLegacyWorkflowRequest implements RequestInterface {
  method = 'post';
  path: string;
  headers: Record<string, any>;

  constructor({ token, groupId }: { token: string; groupId: string }) {
    this.path = `/api/v1/workflows/import-legacy/${groupId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class WorkflowsTriggersRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/triggers';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class WorkflowsActionsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/actions';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
